import React, {Component} from 'react';
import {Form, Icon, message, Modal} from "antd";
import UploadWall from "../../../../components/upload/UploadWall";
import {FILE_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../../../constants";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import BaseComponent from "../../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import { converFileSize} from "../../../../utils";


class Attachment extends BaseComponent {

    static defaultProps = {
        showAddBtn: true,
        height: 280
    };

    constructor(props) {
        super(props);
        this.state={
            fileList:props.itemValue || [],
            maxSize: 1024 * 1024 * 1024 * 2  // 2GB
        }
    }
    componentWillMount() { }


    render() {
        let {fileList} = this.state;
        return (
            <Form.Item label={this.props.label} required={this.props.required} style={{display:"flex",width:'100%',alignItems:"center"}}>
                <Scrollbars autoHeight autoHeightMax={this.props.height} style={{width:'642px'}} className="thrid">
                    <UploadWall
                        style={{marginTop:5,width:625}}
                        calssName={'interUpload'}
                        accept={"."+FILE_TYPE.join(",.")}
                        multiple={true}
                        action="/storage/uploadFile"
                        listType="picture-card"
                        showEmpty={true}
                        fileList={this.props.itemValue}
                        customRequest={new ChunkUpload({
                            checkFileURL:"/storage/checkFile",
                            checkChunkURL:"/storage/checkChunk",
                            uploadChunkURL:"/storage/uploadChunk",
                            chunkUploadOverURL:"/storage/chunkIsUploadOver",
                            mergeChunksURL:"/storage/mergeChunk",
                        }).start}
                        icons={["download"]}
                        uploadBtnName={"上传文件"}
                        showUploadBtn={false}
                        onRemove={this.handleRemoveFileList}
                        listType={"list"}
                        onDownload={(file)=>{
                            if(file.path.indexOf("?") === -1){
                                window.location.href = file.path + "?download=1";
                            }else{
                                window.location.href = file.path + "&download=1";
                            }
                        }}
                    />
                    <style>{`.ant-form-item-control{line-height:20px} `}</style>
                </Scrollbars>

            </Form.Item>
        )
    }


    handleRemoveFileList = file => {
        let fileList = this.state.fileList.filter(item => item.uid !== file.uid);
        this.setState({
            fileList
        },()=>{
            this.props.callBack&& this.props.callBack(fileList)
        });
    };

    onDownload = (file) => {
        console.log(file.path);
        if(file.path) {
            this.request({
                url: file.path+"?download=1",
                method: "downloadGet",
                contentType: "json",
            });
        } else {
            console.log("文件path丢失")
        }
    };
}


export default Attachment;
